import * as canvasActions from '../../../canvas/actions';
import * as canvasLogics from '../../../canvas/logics';
import * as constants from '../../../utils/constants';
import * as mainActions from '../../../main/actions';
import * as mainConstants from '../../../main/constants';
import * as scene7urlUtils from '../../../utils/scene7url';

import { adjustLogoOriginSizeByResolution, detectPmsColors, doColorize } from '../../logics';
import { changeNextgenUiStatus, changeUploadingFileStatus, updateRecentArt } from '../../../nextgen/actions';
import {
  confirmDialogContentType,
  nextGenFlyoutPanelEnum,
  nextGenSidebarTabKeyEnum,
  nextgenScreenMode,
} from '../../../nextgen/constants';
import { get, post } from '../../../utils/request';
import { getCanvasDraggingArea, getCurrentCanvasData, getSelectedImage } from '../../../canvas/selectors';
import { getScreenMode, offsetNewRecentArtOrText } from '../../../nextgen/logics';

import { addBackgorundToRecent } from '../../../template/logics';
import { changeSidebarTabKey } from '../../../sidebar/actions';
import { deleteImage } from '../../../canvas/actions';
import { fillColorCmyk } from '../../../uploadimage/components/LogoColorPicker/logics';
import { isMobileOnly } from 'react-device-detect';
import { isVectorImage } from '../../../utils/ImageUtils';
import { pushToUndoList } from '../../../canvas/components/UndoRedo/logic';
import { recentArtsInitAsync } from '../../../userimage/logics';
import { updateFullPreview } from '../../../preview/logics';
import { v4 as uuidv4 } from 'uuid';

const Max_Waiting_Times = 600;
const Failed_To_Upoad = 'Failed to upload the image.';
const Failed_To_Load = 'Failed to load the image.';
let count = 0;
let progressTimer = null;

export const uploadFile = (uploadFileParams) => {
  const { file, dispatch, vendorId } = uploadFileParams;

  uploadFileParams.frontId = uuidv4();
  const formData = new FormData();
  formData.append('file', file);
  formData.append('frontId', uploadFileParams.frontId);

  const config = {
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent;
      if (uploadFileParams.isBackground) {
        dispatch(
          mainActions.updateWaitingCover({
            percent: Math.ceil((loaded * constants.PERCENT_OF_FILE_UPLOADED) / total),
          }),
        );
      }
    },
  };

  post(
    constants.API_UPLOAD_LOGO + '/upload?frontId=' + uploadFileParams.frontId + '&vendorId=' + vendorId,
    formData,
    config,
  )
    .then((res) => {
      startProgressChecking(uploadFileParams);
    })
    .catch((err) => errorHandler(dispatch, err));
};

export const startProgressChecking = (progressParams) => {
  count = 0;
  getProgressStatus(progressParams);
};

const getProgressStatus = (progressParams) => {
  const dispatch = progressParams.dispatch;

  get(constants.API_PROGRESS + '?frontId=' + progressParams.frontId + '&r=' + Math.random())
    .then((res) => {
      const progressStateData = res.data;

      if (
        progressStateData == null ||
        progressStateData === '' ||
        progressStateData.status === constants.serviceProgressStatus.None
      ) {
        progressTimer = setTimeout(() => {
          getProgressStatus(progressParams);
        }, 1000);

        return;
      }

      // show the progress bar (do not do that in some cases)
      if (
        progressStateData.status !== constants.serviceProgressStatus.None &&
        progressStateData.status !== constants.serviceProgressStatus.Error
      ) {
        if (progressStateData.percent >= 0 && progressParams.isBackground) {
          showProgressText(
            dispatch,
            progressStateData.status,
            progressStateData.divisionStart,
            progressStateData.divisionLength,
            progressStateData.percent
          );
        }
      }
      if (progressStateData.status === constants.serviceProgressStatus.Complete) {
        endProgressChecking();
        dispatch(changeUploadingFileStatus({ file: progressParams.file, complete: true }));

        let command = '';

        const callApi = () => {
          if (progressParams.fromColorize) command = 'GetColorizeResult';
          else if (progressParams.image)
            command = progressParams.isBackground
              ? 'GetBackgroundRemovewhiteResult'
              : progressParams.studioItemType === mainConstants.studioItemType.nonDigital
              ? 'GetLogoRemovewhiteResultNonDigital'
              : 'GetLogoRemovewhiteResultDigital';
          else command = progressParams.isBackground ? 'GetNewBackground' : 'GetNewLogo';

          let api =
            constants.API_PROGRESS +
            '/' +
            command +
            '?frontId=' +
            progressParams.frontId +
            '&vendorId=' +
            progressParams.vendorId;

          if (command === 'GetNewLogo') {
            api += '&itemId=' + progressParams.itemId;
          }

          if (command === 'GetNewBackground' || command === 'GetBackgroundRemovewhiteResult') {
            api +=
              '&allowBlank=' +
              progressParams.canvasData.allowBlank +
              '&canvasWidth=' +
              progressParams.canvasData.fullWidth +
              '&canvasHeight=' +
              progressParams.canvasData.fullHeight;
          }

          if (
            command === 'GetLogoRemovewhiteResultNonDigital' ||
            command === 'GetLogoRemovewhiteResultDigital' ||
            command === 'GetBackgroundRemovewhiteResult'
          ) {
            api += '&option=' + progressParams.newOption;
          }

          //if uploadFileParams.image is undefined, means it is a new upload
          if (progressParams.image) {
            const imageData = roundingCropParameter(progressParams.image.data);
            return post(api, imageData);
          } else {
            return get(api);
          }
        };

        callApi()
          .then((res) => {
            if (progressParams.isBackground) dispatch(mainActions.updateWaitingCover({ percent: 100 }));

            let newLogoData;
            if (command === 'GetColorizeResult') {
              newLogoData = res.data.logo;
              fillColorCmyk(newLogoData.colors, progressParams.colorList || progressParams.imprintColorList);
              dispatch(mainActions.changeLogoEditingStatus({ colorizationFlag: res.data.flag }));
            } else if (command === 'GetNewBackground') {
              dispatch(addBackgorundToRecent(res.data.originBackground));
              newLogoData = res.data.filledBackground;
            } else {
              newLogoData = res.data;
            }

            doActionsAfterProgressComplete(progressParams, newLogoData);
          })
          .catch((err) => errorHandler(dispatch, err));
      } else if (progressStateData.status === constants.serviceProgressStatus.Error) {
        showErrorMessage(dispatch, progressStateData.errorMessage);
      } else {
        //before countinue, check if the backend is inactive
        if (progressStateData.percent >= 99) count++;
        if (count >= Max_Waiting_Times) {
          showErrorMessage(dispatch, Failed_To_Upoad);
          return;
        }

        // finally, continue check after 1 second
        progressTimer = setTimeout(() => {
          getProgressStatus(progressParams);
        }, 1000);
      }
    })
    .catch((err) => errorHandler(dispatch, err));
};

export const doActionsAfterProgressComplete = (progressCheckParams, newImageData) => {
  const { dispatch, itemUseScene7Template } = progressCheckParams;

  if (progressCheckParams.image) {
    // we are doing removewhite/colorize process if image is provided
    if (progressCheckParams.isBackground) {
      dispatch(mainActions.updateTempBackgroundImage(newImageData));
    } else {
      //come here if removewhite/resetToOriginal/colorize(GetImage/ChangeColor/ChangeColorNumber)
      if (!progressCheckParams.imageUrlForPmsColorCheck) {
        dispatch(
          canvasActions.updateCanvasImage({
            canvasKey: progressCheckParams.canvasKey,
            draggingArea: progressCheckParams.draggingArea,
            imageId: progressCheckParams.image.ui.guid,
            newImageData,
            studioItemType: progressCheckParams.studioItemType,
            isHotStamped: progressCheckParams.isHotStamped,
          })
        );
      }
      if (progressCheckParams.callback) progressCheckParams.callback(newImageData);
    }
    hideCover(dispatch);
  } else {
    // no image parameter, means new logo or background
    dispatch(canvasActions.changeCropParameter(null)); // reset crop parameter if new upload

    if (progressCheckParams.isBackground) {
      if (
        !isMobileOnly &&
        progressCheckParams.canvasOverVignetteConfig.vignette &&
        progressCheckParams.canvasOverVignetteConfig.canvasWidth > 0
      ) {
        dispatch(mainActions.changeLogoEditingStatus({ backgroundNeedRemoveWhite: true }));
      }

      dispatch(mainActions.addTempBackgroundImage(newImageData));

      const steps = setBackgroundEditingSteps(dispatch, itemUseScene7Template);

      dispatch(
        mainActions.changeLogoEditingStatus({
          currentStatus: constants.logoEditingStatusEnum.BackgroundRemoveWhite,
          isCropBackground: false,
        })
      );

      canvasLogics.checkBackgroundImageDpi({
        dispatch,
        canvasData: progressCheckParams.canvasData,
        returnStatus: steps[0],
        imageData: newImageData,
        isNewUploaded: true,
      });

      if (progressCheckParams.isNextgenUi) {
        dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Background));
        const firstStep =
          steps[0] === constants.logoEditingStatusEnum.BackgroundRemoveWhite
            ? nextGenFlyoutPanelEnum.BackgroundRemoveWhitePanel
            : steps[0] === constants.logoEditingStatusEnum.BackgroundRotate
            ? nextGenFlyoutPanelEnum.BackgroundRotatePanel
            : nextGenFlyoutPanelEnum.BackgroundCropPanel;
        dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: firstStep } }));
      }
      hideCover(dispatch);
    } else {
      const steps = setLogoEditingSteps({
        dispatch,
        hasOneImprintColorOnly: progressCheckParams.hasOneImprintColorOnly,
        hasWhitePixel: newImageData.hasWhitePixel,
        studioItemType: progressCheckParams.studioItemType,
      });

      if (progressCheckParams.studioItemType === mainConstants.studioItemType.digital) {
        dispatch(canvasActions.unSelectAllText({ canvasKey: progressCheckParams.canvasKey }));

        canvasLogics.checkUploadLogoDpi(dispatch, newImageData);

        if (progressCheckParams.lowDpiLogoGuid && progressCheckParams.lowDpiLogoGuid !== -1) {
          canvasLogics.replaceLowDpiLogo({
            dispatch,
            canvasKey: progressCheckParams.canvasKey,
            lowDpiLogoGuid: progressCheckParams.lowDpiLogoGuid,
          });
        }

        if (progressCheckParams.isNextgenUi) {
          dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Uploads));
          if (progressCheckParams.directToCanvas) {
            dispatch(
              changeNextgenUiStatus({
                flyoutPanel: {
                  currentPanel:
                    getScreenMode() === nextgenScreenMode.small
                      ? nextGenFlyoutPanelEnum.None
                      : nextGenFlyoutPanelEnum.EditImagePanel,
                },
              })
            );
          }
        }
      } else {
        dispatch(mainActions.changeLogoEditingStatus(steps[0]));
        if (progressCheckParams.isNextgenUi) {
          dispatch(changeSidebarTabKey(nextGenSidebarTabKeyEnum.Uploads));
        }
      }

      const adjustedSize = adjustLogoOriginSizeByResolution(
        newImageData,
        progressCheckParams.canvasData.previewResolution
      );
      newImageData.width = adjustedSize.width;
      newImageData.height = adjustedSize.height;

      const callback = (updatedImageData, guid) => {
        const recentArtGuid = addLogoToRecent(dispatch, progressCheckParams);
        dispatch(
          canvasActions.changeLogoStatus({
            canvasKey: progressCheckParams.canvasKey,
            imageId: guid,
            status: constants.elementStatus.SingleSelected,
          })
        );
        showWarningPopupForSingleColorItem(dispatch, progressCheckParams, updatedImageData);

        if (progressCheckParams.studioItemType === mainConstants.studioItemType.digital) {
          checkAndSharpen(dispatch, progressCheckParams, updatedImageData, guid, recentArtGuid);
          if (progressCheckParams.nextgenUiStatus && progressCheckParams.nextgenUiStatus.artGuidToBeReplaced)
            removeArtToBeReplaced(progressCheckParams);

          hideCover(dispatch);
          dispatch(pushToUndoList(constants.undoRedoType.UploadLogo));
          dispatch(updateFullPreview({ noWaiting: true }));
        } else if (progressCheckParams.studioItemType === mainConstants.studioItemType.screenPrintedDigital) {
          autoColorizeForUploadLogo({
            colorizeParams: progressCheckParams,
            updatedImageData,
            guid,
            callbackAfterColorize: (colorizedImageData) => {
              //save new logo'colors to the origin color list
              dispatch(
                canvasActions.saveImageOriginColors({ canvasKey: progressCheckParams.canvasKey, imageId: guid })
              );
              resizeAndCenterImage(dispatch, colorizedImageData, guid, progressCheckParams);
              confirmAutoColorize(dispatch, progressCheckParams, colorizedImageData, guid, recentArtGuid);
            },
          });
        }
      };

      if (progressCheckParams.directToCanvas) {
        addNewElement(dispatch, progressCheckParams, newImageData, callback);
      } else {
        directAddLogoToRecent(dispatch, progressCheckParams, newImageData);
        hideCover(dispatch);
      }
    }

    dispatch(mainActions.changeLogoEditingStatus({ forceHideApplyNotice: true }));
  }
};

export const confirmAutoColorize = (dispatch, colorizeParams, updatedImageData, guid, recentArtGuid) => {
  dispatch(
    mainActions.showConfirmDialog({
      title: 'Artwork Color Changes',
      okText: 'Continue',
      cancelText: 'Upload New Artwork',
      contentType: confirmDialogContentType.ArtworkColorChanges,
      contentProps: { artData: updatedImageData },
      onCancel: () => {
        dispatch(deleteImage({ canvasKey: colorizeParams.canvasKey, guid }));
        dispatch(changeNextgenUiStatus({ flyoutPanel: { currentPanel: nextGenFlyoutPanelEnum.UploadPanel } }));
        dispatch(pushToUndoList(constants.undoRedoType.UploadLogo));
      },
      onOk: () => {
        dispatch(updateRecentArtThunk(colorizeParams.imprintAreaCode, recentArtGuid));
        if (colorizeParams.nextgenUiStatus && colorizeParams.nextgenUiStatus.artGuidToBeReplaced)
          removeArtToBeReplaced(colorizeParams);

        if (!checkAndSharpen(dispatch, colorizeParams, updatedImageData, guid, recentArtGuid)) {
          //no sharpening needed,just detect pms colors
          detectPmsColors({
            dispatch,
            canvasKey: colorizeParams.canvasKey,
            vendorId: colorizeParams.vendorId,
            image: updatedImageData,
            guid,
            callback: () => {
              dispatch(updateRecentArtThunk(colorizeParams.imprintAreaCode, recentArtGuid));
              dispatch(pushToUndoList(constants.undoRedoType.UploadLogo));
            },
          });
        }
      },
    })
  );
};

export const removeArtToBeReplaced = (params) => {
  const { dispatch, canvasKey } = params;
  dispatch(deleteImage({ canvasKey, guid: params.nextgenUiStatus.artGuidToBeReplaced }));
  dispatch(changeNextgenUiStatus({ artGuidToBeReplaced: null }));
};

export const autoColorizeForUploadLogo = ({ colorizeParams, updatedImageData, guid, callbackAfterColorize }) => {
  const selectedLogo = { data: updatedImageData, ui: { guid } };
  const {
    dispatch,
    studioItemType,
    imprintColorList,
    currentImprintFormat,
    imprintOptionType,
    allColorsInUse,
    isMultipleArtMultipleColor,
  } = colorizeParams;

  var isSingleColorItem = currentImprintFormat.maxColorCount === 1 ? true : false;
  var isTextLogo = imprintOptionType === constants.imprintOptionType.TextLogo;
  let newImprintColorList = isSingleColorItem && isTextLogo ? selectedLogo.data.colors : imprintColorList;

  if (studioItemType === mainConstants.studioItemType.screenPrintedDigital) {
    if (isMultipleArtMultipleColor && allColorsInUse) {
      newImprintColorList = Object.assign([], newImprintColorList);
      newImprintColorList = newImprintColorList.filter(
        (color) => !allColorsInUse.find((c) => c.colorId == color.colorId)
      );
    }
    if (allColorsInUse) newImprintColorList = allColorsInUse.concat(newImprintColorList);
    dispatch(mainActions.showTransparencyCover());
  }

  doColorize({
    ...colorizeParams,
    imprintColorList: newImprintColorList,
    selectedLogo,
    maxColorCount: currentImprintFormat.maxColorCount,
    guid,
    colorsInUse: allColorsInUse ? allColorsInUse.length : 0,
    replaceColor: true,
    callbackAfterColorize,
  });
};

export const setLogoEditingSteps = ({ dispatch, hasOneImprintColorOnly, hasWhitePixel, studioItemType }) => {
  const steps = [];
  if (studioItemType === mainConstants.studioItemType.nonDigital) {
    if (hasWhitePixel) steps.push(constants.logoEditingStatusEnum.NonDigitalLogoRemoveWhite);
    steps.push(constants.logoEditingStatusEnum.NonDigitalLogoCrop);
    steps.push(constants.logoEditingStatusEnum.NonDigitalLogoRotate);
    if (!hasOneImprintColorOnly) steps.push(constants.logoEditingStatusEnum.NonDigitalLogoColor);
  } else if (studioItemType === mainConstants.studioItemType.screenPrintedDigital) {
    steps.push(nextGenFlyoutPanelEnum.EditImagePanel);
  } else {
    // implicit steps for Digital
    if (hasWhitePixel) steps.push(constants.logoEditingStatusEnum.DigitalLogoRemoveWhite);
  }
  dispatch(mainActions.changeLogoEditingStatus({ steps }));
  return steps;
};

export const setBackgroundEditingSteps = (dispatch, itemUseScene7Template) => {
  const steps = [];
  if (itemUseScene7Template) {
    steps.push(constants.logoEditingStatusEnum.BackgroundRemoveWhite);
    steps.push(constants.logoEditingStatusEnum.BackgroundCrop);
    steps.push(constants.logoEditingStatusEnum.BackgroundRotate);
  } else {
    steps.push(constants.logoEditingStatusEnum.BackgroundRemoveWhite);
    steps.push(constants.logoEditingStatusEnum.BackgroundRotate);
    steps.push(constants.logoEditingStatusEnum.BackgroundCrop);
  }
  dispatch(mainActions.changeLogoEditingStatus({ steps }));
  return steps;
};

const showProgressText = function (dispatch, status, divisionStart, divisionLength, percent) {
  const finalPercent = Math.ceil(divisionStart + (percent / 100) * divisionLength);

  let text = '';
  // if (status === constants.serviceProgressStatus.Uploading) text = 'Push to Service...';
  // else if (status === constants.serviceProgressStatus.Processing) text = 'Processing...';
  // else if (status === constants.serviceProgressStatus.Downloading) text = 'Downloading...';

  dispatch(mainActions.updateWaitingCover({ percent: finalPercent, text: text }));
};

const endProgressChecking = function () {
  clearTimeout(progressTimer);
  progressTimer = null;
};

const errorHandler = (dispatch, err) => {
  canvasLogics.consoleLog(err);
  showErrorMessage(dispatch, Failed_To_Load);
};

const showErrorMessage = (dispatch, message) => {
  endProgressChecking();
  hideCover(dispatch);
  dispatch(mainActions.showMessageBox(message));
};

const addNewElement = (dispatch, progressCheckParams, newImageData, callback) => {
  dispatch(
    canvasLogics.addNewElement((elementId, layerIndex) => {
      const guid = uuidv4();
      newImageData.zIndex = layerIndex;
      dispatch(
        canvasActions.addNewLogo({
          canvasKey: progressCheckParams.canvasKey,
          draggingArea: progressCheckParams.draggingArea,
          logoImageData: newImageData,
          elementId,
          layerIndex,
          studioItemType: progressCheckParams.studioItemType,
          isHotStamped: progressCheckParams.isHotStamped,
          imprintColors: progressCheckParams.imprintColorList,
          maxColorCount: progressCheckParams.maxColorCount,
          textColor: progressCheckParams.textColor,
          defaultImprintColor: progressCheckParams.defaultImprintColor,
          guid,
          centerLogo: progressCheckParams.isNextgenUi,
        })
      );

      if (callback) callback(newImageData, guid);
    })
  );
};

export const checkAndSharpen = (dispatch, sharpenParams, newImageData, guid, recentArtGuid) => {
  if (sharpenParams.studioItemType === mainConstants.studioItemType.nonDigital) return false;

  sharpenParams.needSharpen =
    !isVectorImage(newImageData.fileName) &&
    (Math.ceil(newImageData.logoResolutionX < constants.MIN_CANVAS_DPI) ||
      Math.ceil(newImageData.logoResolutionY < constants.MIN_CANVAS_DPI))
      ? true
      : false;
  if (!sharpenParams.needSharpen) return false;

  dispatch(mainActions.showTransparencyCover());
  dispatch(changeNextgenUiStatus({ showCanvasCover: true }));

  // clear ImagingServiceSessionId to make sure the colorized image is used
  newImageData = Object.assign({}, newImageData);
  newImageData.imagingServiceSessionIdOfNoColorize = newImageData.imagingServiceSessionId;
  newImageData.imagingServiceSessionIdListOfNoColorize = Object.assign([], newImageData.imagingServiceSessionIdList);
  newImageData.imagingServiceSessionId = null;
  newImageData.imagingServiceSessionIdList = Object.assign([], newImageData.imagingServiceSessionIdList);
  newImageData.imagingServiceSessionIdList[newImageData.removeWhiteOption] = null;

  doSharpen({
    dispatch,
    guid,
    ...sharpenParams,
    imageData: newImageData,
    newUploadedLogo: true,
    centerLogo: sharpenParams.isNextgenUi,
    callback: (sharpenedImageData, guid) => {
      dispatch(updateRecentArtThunk(sharpenParams.imprintAreaCode, recentArtGuid));
      if (sharpenParams.studioItemType === mainConstants.studioItemType.screenPrintedDigital) {
        detectPmsColors({
          dispatch,
          canvasKey: sharpenParams.canvasKey,
          vendorId: sharpenParams.vendorId,
          image: sharpenedImageData,
          guid,
          callback: () => {
            dispatch(updateRecentArtThunk(sharpenParams.imprintAreaCode, recentArtGuid));
            dispatch(pushToUndoList(constants.undoRedoType.UploadLogo));
          },
        });
      } else {
        dispatch(pushToUndoList(constants.undoRedoType.UploadLogo));
      }
    },
  });

  return true;
};

export const resizeAndCenterImage = (dispatch, imageData, guid, params) => {
  const { studioItemType, draggingArea, canvasKey } = params;

  canvasLogics.adjustLogoOriginSizeByLimitation(imageData, studioItemType, draggingArea);
  const x = Math.round((draggingArea.width - imageData.width) / 2 + draggingArea.x);
  const y = Math.round((draggingArea.height - imageData.height) / 2 + draggingArea.y);
  dispatch(
    canvasActions.resizeElement({
      imprintAreaKey: canvasKey,
      guid,
      x: x,
      y: y,
      width: imageData.width,
      height: imageData.height,
    })
  );
};

const updateRecentArtThunk = (imprintAreaCode, recentArtGuid) => (dispatch, getState) => {
  const state = getState();
  const image = getSelectedImage(state);
  if (recentArtGuid) dispatch(updateRecentArt({ imprintAreaCode, recentArtGuid, image }));
};

export const doSharpen = async (params) => {
  const {
    dispatch,
    imageData,
    guid,
    canvasKey,
    vendorId,
    studioItemType,
    draggingArea,
    callback,
    needPushToUndo,
    newUploadedLogo,
    centerLogo,
  } = params;
  if (typeof imageData == 'undefined' || !imageData) {
    dispatch(mainActions.showMessageBox('No image selected'));
  }

  const frontId = uuidv4();
  const sharpenRequest = { frontId, vendorId, image: Object.assign({}, imageData) };
  // studioItemType property is needed in backend serialization
  if (!sharpenRequest.image.studioItemType) sharpenRequest.image.studioItemType = studioItemType;

  try {
    const res = await post(constants.API_EDIT_LOGO + '/SharpenLogo', sharpenRequest);
    if (res.data) {
      if (params.newOption === undefined && draggingArea) {
        canvasLogics.adjustLogoOriginSizeByLimitation(res.data, studioItemType, draggingArea);
        if (centerLogo) dispatch(centerNewAddedElement(res, guid));
      }
      if (studioItemType === mainConstants.studioItemType.screenPrintedDigital) {
        if (res.data.colors) {
          if (params.imprintColorList) fillColorCmyk(res.data.colors, params.imprintColorList);
        }
      }

      dispatch(
        canvasActions.updateCanvasImage({
          canvasKey,
          imageId: guid,
          newImageData: res.data,
          draggingArea: params.newOption === undefined ? draggingArea : null,
          studioItemType,
          newUploadedLogo,
        })
      );

      dispatch(canvasActions.changeToSharpened({ canvasKey, imageId: guid }));
      if (callback) callback(res.data, guid);
    } else {
      if (studioItemType === mainConstants.studioItemType.digital && callback) callback(imageData, guid);
      dispatch(mainActions.showMessageBox('Sharpen failed.'));
    }
    if (needPushToUndo) dispatch(pushToUndoList(constants.undoRedoType.ChangeTemplateOrEditElement));
    if (!params.keepCover) hideCover(dispatch);
  } catch (err) {
    canvasLogics.consoleLog(err);
    dispatch(mainActions.showMessageBox(err.message));
    hideCover(dispatch);
    if (studioItemType === mainConstants.studioItemType.digital && callback) callback(imageData, guid);
  }
};

const directAddLogoToRecent = (dispatch, progressCheckParams, newImageData) => {
  newImageData.itemUseScene7Template = true;
  newImageData.originalOptions = {
    autoCropRectOrigin: newImageData.autoCropRect,
    cropRectOrigin: newImageData.cropRect,
    finalCropRectOrigin: newImageData.finalCropRect,
  };
  dispatch(
    recentArtsInitAsync({
      formatkey: progressCheckParams.canvasKey,
      userImage: Object.assign({}, newImageData, {
        guid: uuidv4(),
        thumbnail: scene7urlUtils.getLogoImprintViewUrl(newImageData),
      }),
    })
  );
};

const addLogoToRecent = (dispatch, progressCheckParams) => {
  const recentArtGuid = uuidv4();
  dispatch(
    canvasLogics.addLogoToRecent((updatedImageData) => {
      dispatch(
        recentArtsInitAsync({
          formatkey: progressCheckParams.canvasKey,
          userImage: Object.assign({}, updatedImageData, {
            guid: uuidv4(),
            thumbnail: scene7urlUtils.getLogoImprintViewUrl(updatedImageData),
            recentArtGuid,
          }),
        })
      );
    })
  );
  return recentArtGuid;
};

const showWarningPopupForSingleColorItem = (dispatch, progressCheckParams, newImageData) => {
  if (progressCheckParams.studioItemType !== mainConstants.studioItemType.nonDigital) return;
  if (progressCheckParams.maxColorCount !== 1) return; // only for single color item
  if (progressCheckParams.processType === constants.ProcessTypes.FullColorScreened) return; // not for FullColor non-digital item
  if (newImageData.isLogo) return; // skip if logo color already exists

  dispatch(mainActions.showMessageBox(constants.SINGLE_COLOR_WARNING));
};

export const doActionsBeforeUpload = ({
  dispatch,
  currentStatus,
  canvasKey,
  selectedLogo,
  isBackground,
  fromMobileButtonBar,
  digitalUploadNew,
}) => {
  if (currentStatus === constants.logoEditingStatusEnum.LogoCropping) dispatch(mainActions.hideTransparencyCover());

  if (digitalUploadNew) {
    dispatch(mainActions.setNewUploadLogoFlag(true));
    if (selectedLogo) dispatch(deleteImage({ canvasKey, guid: selectedLogo.ui.guid }));
  }

  if (fromMobileButtonBar && !isBackground) {
    // if logos for non-digital mobile
    dispatch(mainActions.setNewUploadLogoFlag(true));
    if (selectedLogo) dispatch(deleteImage({ canvasKey, guid: selectedLogo.ui.guid }));
    dispatch(mainActions.changeLogoEditingStatus(constants.logoEditingStatusEnum.None));
  }

  // reset logoEditingStatus to none once users select Upload New to avoid blocked by dpiWarningMiddleware
  if (currentStatus === constants.logoEditingStatusEnum.DpiWarningButton) {
    dispatch(mainActions.changeLogoEditingStatus(constants.logoEditingStatusEnum.None));
    dispatch(mainActions.switchShowWarningMessageContainer({ show: false }));

    if (isMobileOnly) {
      dispatch(mainActions.setCurrentStep(mainConstants.configuratorStep.canvas));
    }

    if (isBackground) {
      dispatch(canvasActions.removeBackgroundImage(canvasKey));
      dispatch(changeSidebarTabKey(constants.sidebarTabKeyEnum.Background));
    } else {
      if (selectedLogo) dispatch(deleteImage({ canvasKey, guid: selectedLogo.ui.guid }));
      dispatch(changeSidebarTabKey(constants.sidebarTabKeyEnum.Logo));
    }
  } else if (currentStatus === constants.logoEditingStatusEnum.DpiWarningPanel) {
    if (!isBackground) {
      // only need to remove previous logo on warning panel
      // background has a temp status so not in customBackgroundDict
      if (selectedLogo) dispatch(deleteImage({ canvasKey, guid: selectedLogo.ui.guid }));
    }
  }
};

export const checkFileBeforeUpload = (dispatch, file) => {
  if (file.size > constants.MAX_UPLOAD_FILE_SIZE) {
    dispatch(
      mainActions.showMessageBox('The file exceeds our 30 MB size limit. Please select another file to upload.')
    );
    return false;
  }

  const extension = file.name.toLowerCase().substring(file.name.lastIndexOf('.') + 1);
  if (
    extension !== 'jpg' &&
    extension !== 'jpeg' &&
    extension !== 'tif' &&
    extension !== 'tiff' &&
    extension !== 'eps' &&
    extension !== 'pdf' &&
    extension !== 'ai' &&
    extension !== 'psd' &&
    extension !== 'gif' &&
    extension !== 'bmp' &&
    extension !== 'png'
  ) {
    dispatch(mainActions.showMessageBox('The file format cannot be recognized. Please select another file to upload.'));
    return false;
  }

  return true;
};

export const hideCover = (dispatch) => {
  dispatch(mainActions.hideWaitingCover({ reset: true }));
  dispatch(changeNextgenUiStatus({ showUploadCover: false }));
  dispatch(changeNextgenUiStatus({ showCanvasCover: false }));
  dispatch(mainActions.hideTransparencyCover());

  dispatch(changeNextgenUiStatus({ isRemovingWhite: false }));
  dispatch(changeNextgenUiStatus({ isReseting: false }));
  dispatch(changeNextgenUiStatus({ isRotating: false }));
};

export const centerNewAddedElement = (newElement, newElementGuid) => (dispatch, getState) => {
  const state = getState();
  const draggingArea = getCanvasDraggingArea(state);
  const canvasData = getCurrentCanvasData(state);

  newElement.data.x = Math.round((draggingArea.width - newElement.data.width) / 2 + draggingArea.x);
  newElement.data.y = Math.round((draggingArea.height - newElement.data.height) / 2 + draggingArea.y);
  offsetNewRecentArtOrText(newElement, canvasData.imageList, newElementGuid);
};

const roundingCropParameter = (imageData) => {
  const cropRect = { ...imageData.cropRect };
  cropRect.x = Math.round(cropRect.x);
  cropRect.y = Math.round(cropRect.y);
  cropRect.width = Math.round(cropRect.width);
  cropRect.height = Math.round(cropRect.height);

  const finalCropRect = { ...imageData.finalCropRect };
  finalCropRect.x = Math.round(finalCropRect.x);
  finalCropRect.y = Math.round(finalCropRect.y);
  finalCropRect.width = Math.round(finalCropRect.width);
  finalCropRect.height = Math.round(finalCropRect.height);
  return { ...imageData, cropRect, finalCropRect };
};
